import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

type Action<T> = T extends Function ? T : never
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ArgumentsType<T> = T extends (...args: infer V) => any ? Partial<V> : never

export function useAction<T>(actionCreator: Action<T>, ...rest: ArgumentsType<T>): (...args: ArgumentsType<T>) => void {
  const dispatch = useDispatch()

  return useCallback(
    (...args) => {
      // Hack, that allows making checks based on store state in sagas.
      // This timeout leaves execution window to commit changes in redux store before the next action call.
      // Without it, action calls will be batched by the react scheduler, so all of the triggered sagas will rely on the same state snapshot.
      // For example, if you want to make a request debounce in a saga based on some flag in the store
      // all of the 'yield select()' sagas batched by the scheduler will point to the same store snapshot.
      setTimeout(() => dispatch(actionCreator(...rest, ...args)), 0)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [actionCreator, dispatch, ...rest],
  )
}
